export const dtoToUrlParams = (dto: { [k: string]: string | number | boolean }) => {
  dto = Object.fromEntries(
    Object.entries(dto).map(([ k, v ]) => [
      k, v.toString()
    ])
  )

  return new URLSearchParams(dto as Record<string, string>)
}